const CODE_REMINDER_REQUEST = 'CODE_REMINDER_REQUEST';
const CODE_REMINDER_SUCCESS = 'CODE_REMINDER_SUCCESS';
const CODE_REMINDER_FAILURE = 'CODE_REMINDER_FAILURE';

export {
  CODE_REMINDER_REQUEST,
  CODE_REMINDER_SUCCESS,
  CODE_REMINDER_FAILURE,
};
